var _effectorFileName = "/builds/gmini/front-ui-kit/src/Select/components/RenderOptions/RenderOptions.tsx";
import { useCallback, useEffect, useState } from 'react';
import { isFieldIncludedToSearch } from '../../../utils/isFieldIncludedToSearch';
import { DEFAULT_MESSAGE_EMPTY_LIST } from '../../constants';
import { OptionWrapper } from '../OptionWrapper';
import { RenderOption } from '../RenderOption';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const RenderOptions = ({
  inputRef,
  options,
  loading,
  emptyOptionListMessage,
  renderOption,
  focusedOptionIdx,
  onMouseEnterOption,
  onSelect,
  value,
  onBlurHandler,
  inputValue,
  getOptionLabel,
  renderLoading,
  optionDataTestIdPrefix,
  optionProps
}) => {
  const [optionList, setOptionList] = useState(options);
  const isOptionIncludedToSearch = useCallback(option => isFieldIncludedToSearch(getOptionLabel(option), inputValue), [getOptionLabel, inputValue]);
  useEffect(() => {
    if (!options) {
      return;
    }

    setOptionList(value && getOptionLabel(value) === inputValue ? options : options.filter(option => isOptionIncludedToSearch(option)));
  }, [getOptionLabel, inputValue, isOptionIncludedToSearch, options, value]);

  if (loading) {
    return renderLoading ? /*#__PURE__*/_jsx(_Fragment, {
      children: renderLoading()
    }) : /*#__PURE__*/_jsx(OptionWrapper, {
      onClick: () => {
        var _inputRef$current;

        return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      },
      disabled: true,
      children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
    });
  }

  if (optionList && optionList.length > 0) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: optionList.map((option, idx) => {
        const active = JSON.stringify(value) === JSON.stringify(option);
        return renderOption ? renderOption({
          option,
          idx,
          hover: focusedOptionIdx === idx,
          onClose: onBlurHandler,
          inputValue,
          active,
          onMouseEnterOption
        }) : /*#__PURE__*/_jsx(RenderOption // eslint-disable-next-line react/no-array-index-key
        , {
          option: option,
          hover: focusedOptionIdx === idx,
          onSelect: onSelect,
          onMouseEnter: () => onMouseEnterOption(idx),
          active: active,
          getOptionLabel: getOptionLabel,
          isHighlightEnabled: !value,
          highlightingPattern: inputValue,
          "data-test-id": `${optionDataTestIdPrefix}_${idx}`,
          ...optionProps
        }, idx);
      })
    });
  }

  return /*#__PURE__*/_jsx(OptionWrapper, {
    onClick: () => {
      var _inputRef$current2;

      return (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    },
    disabled: true,
    children: emptyOptionListMessage || DEFAULT_MESSAGE_EMPTY_LIST
  });
};